import { getQueryParamValue } from "../../util";

export const StyleProvider = ({children}: React.PropsWithChildren) => {
    const overrideStyle = getQueryParamValue('style');

    return <>
        {overrideStyle ? <link rel="stylesheet" type="text/css" href={`./styles/${overrideStyle}`} /> : null}
        {children}
    </>
}